// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".share-button[data-v-00f07ebf]{display:flex;justify-content:center;align-items:center;position:absolute;cursor:pointer;z-index:4;right:15px;bottom:-20px;border-radius:50%;width:40px;height:40px;background:#000517}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
